document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.primary-nav');
  toggle?.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    nav.classList.remove('open');
    toggle?.setAttribute('aria-expanded', 'false');
  }));
});

// Homepage and fallback catalogue cards use exact canonical product URLs.
// This click handler prevents theme-preview routing or stale section settings
// from replacing the intended product destination.
document.addEventListener('click', (event) => {
  const productLink = event.target.closest('[data-product-url]');
  if (!productLink) return;

  const destination = productLink.getAttribute('data-product-url');
  if (!destination) return;

  event.preventDefault();
  window.location.assign(destination);
});


// 19+ age verification gate. Confirmation is remembered for 30 days.
document.addEventListener('DOMContentLoaded', () => {
  const gate = document.getElementById('BppAgeGate');
  if (!gate || !document.documentElement.classList.contains('bpp-age-required')) return;

  const confirmButton = gate.querySelector('[data-age-confirm]');
  const focusable = Array.from(gate.querySelectorAll('button, a[href]'));
  const pageElements = Array.from(document.body.children).filter((element) => element !== gate);

  pageElements.forEach((element) => element.setAttribute('inert', ''));
  window.setTimeout(() => confirmButton?.focus(), 0);

  const allowEntry = () => {
    try {
      const thirtyDays = 30 * 24 * 60 * 60 * 1000;
      window.localStorage.setItem('bpp_age_verified_until', String(Date.now() + thirtyDays));
    } catch (error) {}

    document.documentElement.classList.remove('bpp-age-required');
    document.documentElement.classList.add('bpp-age-verified');
    pageElements.forEach((element) => element.removeAttribute('inert'));
    gate.setAttribute('aria-hidden', 'true');
    gate.remove();
  };

  confirmButton?.addEventListener('click', allowEntry);

  gate.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
});
